import { render, staticRenderFns } from "./NotificacionModal.vue?vue&type=template&id=22f5f51a&"
import script from "./NotificacionModal.vue?vue&type=script&lang=js&"
export * from "./NotificacionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports